module.exports = __webpack_public_path__ + "static/media/COPRA-logo-white.270d8d67.png";